// src/project/data/triggers/submitKyc.js
// Step 3 du flow KYC V3 : Soumission du KYC pour validation
// POST /kyc/submit/{kycId}
import { buildActionUrl, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'

export default {
  postUrl(payload) {
    const userId = getUserId()
    const kycId = payload?.kycId || `kyc_rider_${userId}`
    return buildActionUrl(RIDER_ENDPOINTS.KYC_SUBMIT(kycId))
  },
  format(payload) {
    // Pas de body nécessaire pour la soumission
    return {}
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: { submitted: false, message: raw?.message || 'Erreur lors de la soumission du KYC' },
      }
    }
    return {
      statusCode: 200,
      data: {
        submitted: true,
        status: 'pending',
        kyc: raw?.data || null,
        message: 'KYC soumis pour validation',
      },
    }
  },
}
